const limitFilter = (str, limit = 27) => (str.length > limit ? str.slice(0, limit) + '...' : str);

export default limitFilter;
